import { twMerge } from 'tailwind-merge';

const Arrow = ({
	variation,
	className,
}: {
	variation: 'up_01' | 'down_01' | 'down_02' | 'down_03';
	className?: string;
}) => {
	switch (variation) {
		default:
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 26 39"
					className={twMerge(
						'text-black/40 dark:text-white/60',
						className,
					)}
					aria-hidden="true"
					role="presentation"
				>
					<path
						fill="currentColor"
						d="M11.972 37.254a1 1 0 001.866.72l-1.866-.72zm.585-17.699l.849-.528-.85.528zm-9.429 6.412l-.75.66.013.015.014.015.723-.69zM16.711.374a1 1 0 00-1.357.4L11.051 8.68a1 1 0 101.756.956l3.826-7.026 7.026 3.825a1 1 0 00.956-1.756L16.711.374zm-2.873 37.6c.508-1.315 1.34-4.483 1.591-8.06.25-3.556-.056-7.724-2.023-10.887l-1.699 1.056c1.63 2.622 1.968 6.27 1.727 9.69-.239 3.398-1.032 6.368-1.462 7.48l1.866.722zm-.432-18.947c-1.278-2.055-3.048-3.167-4.905-3.488-1.834-.316-3.684.15-5.143 1.113C1.9 17.615.771 19.115.468 20.92c-.308 1.832.257 3.83 1.91 5.707l1.501-1.32c-1.321-1.503-1.631-2.91-1.439-4.055.197-1.172.946-2.222 2.02-2.93 1.073-.709 2.412-1.034 3.7-.812 1.265.218 2.554.976 3.547 2.573l1.699-1.056zm-11.001 7.63c1.765 1.852 4.08 2.519 6.402 2.076 2.293-.438 4.52-1.937 6.277-4.27 3.525-4.68 5.26-12.81 2.108-23.493l-1.919.565c3.025 10.253 1.259 17.682-1.786 21.725-1.529 2.03-3.354 3.183-5.055 3.508-1.672.32-3.294-.143-4.58-1.491l-1.447 1.38z"
					></path>
				</svg>
			);
		case 'down_01':
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 412 44"
					className={twMerge(
						'text-black/40 dark:text-white/60',
						className,
					)}
					aria-hidden="true"
					role="presentation"
				>
					<path
						fill="url(#paint0_linear_278_35)"
						fillOpacity="0.4"
						d="M4.312 1.584A1 1 0 002.688.416l1.624 1.168zm52.704 26.041l.275.962-.275-.962zm148.403-5.357l.171-.985-.171.985zM133 31.5l.217.976L133 31.5zM387 6l.01-1-.01 1zm-7.69 29.276a1 1 0 00-.034 1.414l6.209 6.515a1 1 0 001.448-1.38l-5.519-5.791 5.791-5.52a1 1 0 10-1.379-1.447l-6.516 6.209zM2.688.416c-3.894 5.412-3.765 16.439 4.14 24.07 7.963 7.689 23.576 11.782 50.463 4.1l-.55-1.922c-26.596 7.598-41.314 3.345-48.524-3.617C.947 16.03 1.06 6.103 4.312 1.584L2.688.416zm202.56 22.837c12.044 2.09 24.24 3.985 35.127 4.564 10.856.576 20.565-.146 27.549-3.411l-.847-1.812c-6.517 3.046-15.807 3.798-26.596 3.225-10.758-.57-22.853-2.447-34.891-4.536l-.342 1.97zm62.716 1.133c5.566-2.916 7.813-7.645 7.534-11.766C275.221 8.54 272.4 5 268 5v2c3.1 0 5.279 2.46 5.502 5.755.221 3.254-1.532 7.274-6.466 9.86l.928 1.77zM268 5c-4.401 0-7.208 3.539-7.62 7.586-.416 4.088 1.537 8.837 6.619 11.78l1.002-1.732c-4.418-2.557-5.965-6.559-5.631-9.845.338-3.328 2.531-5.79 5.63-5.79V5zM57.29 28.587c5.824-1.664 12.563-3.884 19.544-6.101 6.995-2.22 14.25-4.444 21.154-6.133 6.913-1.69 13.427-2.834 18.947-2.918 5.55-.085 9.912.905 12.705 3.282l1.296-1.523c-3.35-2.851-8.317-3.846-14.031-3.759-5.742.088-12.425 1.271-19.392 2.976-6.975 1.706-14.284 3.946-21.284 6.169-7.014 2.227-13.702 4.43-19.488 6.084l.55 1.923zm73.737-11.958c.794-.87 2.047-1.57 3.795-2.075 1.742-.502 3.905-.789 6.433-.885 5.057-.193 11.428.38 18.514 1.382 14.197 2.007 30.954 5.682 45.479 8.202l.342-1.97c-14.373-2.494-31.326-6.203-45.541-8.213-7.121-1.006-13.632-1.6-18.87-1.4-2.62.1-4.957.4-6.911.962-1.947.562-3.585 1.407-4.719 2.65l1.478 1.347zm-1.387.088c4.924 4.19 6.335 7.59 6.27 9.853-.063 2.213-1.537 3.6-3.127 3.954l.434 1.952c2.411-.536 4.601-2.648 4.693-5.849.09-3.15-1.856-7.078-6.974-11.433l-1.296 1.523zm3.143 13.807c-2.199.488-4.478-.79-5.352-3.278-.863-2.456-.366-6.273 3.596-10.617l-1.478-1.348c-4.288 4.702-5.185 9.268-4.004 12.628 1.169 3.33 4.372 5.3 7.672 4.567l-.434-1.952zm134.393-6.078c26.548 9.102 48.225 4.576 67.421-2.129 4.792-1.673 9.434-3.485 13.951-5.25 4.523-1.77 8.916-3.491 13.238-5 8.648-3.017 16.93-5.15 25.204-5.067l.02-2c-8.619-.086-17.16 2.135-25.883 5.18-4.363 1.522-8.793 3.258-13.307 5.024-4.521 1.767-9.13 3.566-13.883 5.225-18.982 6.63-40.16 11.023-66.113 2.125l-.648 1.892zM386.99 7c7.465.074 13.22 2.008 17.033 4.767 3.817 2.76 5.645 6.3 5.478 9.673-.166 3.357-2.324 6.838-7.092 9.46-4.779 2.63-12.117 4.348-22.385 4.1l-.048 2c10.483.252 18.207-1.492 23.397-4.347 5.2-2.86 7.917-6.885 8.126-11.115.208-4.214-2.089-8.343-6.303-11.392C400.978 7.095 394.795 5.078 387.01 5l-.02 2z"
					></path>
					<defs>
						<linearGradient
							id="paint0_linear_278_35"
							x1="1"
							x2="468"
							y1="0"
							y2="0"
							gradientUnits="userSpaceOnUse"
						>
							<stop
								stopOpacity="0"
								stopColor="currentColor"
							></stop>
							<stop
								offset="0.125"
								stopColor="currentColor"
							></stop>
							<stop offset="1" stopColor="currentColor"></stop>
						</linearGradient>
					</defs>
				</svg>
			);
		case 'down_02':
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 388 37"
					className={twMerge(
						'text-black/40 dark:text-white/60',
						className,
					)}
					aria-hidden="true"
					role="presentation"
				>
					<path
						fill="url(#paint0_linear_278_36)"
						d="M4.125 1.584A1 1 0 102.502.416l1.623 1.168zM56.83 27.625l.275.962-.275-.962zm148.404-5.357l.171-.985-.171.985zM132.814 31.5l.217.976-.217-.976zm246.258 5.17a1 1 0 001.413.071l6.673-6.038a1 1 0 10-1.341-1.483l-5.933 5.367-5.367-5.932a1 1 0 00-1.483 1.342l6.038 6.674zM2.502.417c-3.895 5.412-3.765 16.439 4.139 24.07 7.963 7.689 23.576 11.782 50.463 4.1l-.55-1.922C29.959 34.262 15.24 30.009 8.03 23.047.76 16.03.874 6.103 4.125 1.584L2.502.416zm202.56 22.837c12.043 2.09 24.239 3.985 35.126 4.564 10.856.576 20.565-.146 27.549-3.411l-.847-1.812c-6.516 3.046-15.807 3.798-26.596 3.225-10.758-.57-22.852-2.447-34.89-4.536l-.342 1.97zm62.716 1.133c5.565-2.916 7.813-7.645 7.533-11.766-.276-4.08-3.098-7.62-7.497-7.62v2c3.1 0 5.278 2.46 5.502 5.755.22 3.254-1.532 7.274-6.466 9.86l.928 1.77zM267.814 5c-4.402 0-7.209 3.539-7.62 7.586-.416 4.088 1.536 8.837 6.619 11.78l1.002-1.732c-4.418-2.557-5.966-6.559-5.632-9.845.339-3.328 2.532-5.79 5.631-5.79V5zM57.104 28.587c5.823-1.664 12.563-3.884 19.544-6.101 6.995-2.22 14.249-4.444 21.154-6.133 6.912-1.69 13.426-2.834 18.947-2.918 5.549-.085 9.911.905 12.704 3.282l1.297-1.523c-3.351-2.851-8.318-3.846-14.032-3.759-5.741.088-12.424 1.271-19.392 2.976-6.974 1.706-14.283 3.946-21.283 6.169-7.015 2.227-13.703 4.43-19.488 6.084l.55 1.923zm73.736-11.958c.795-.87 2.048-1.57 3.796-2.075 1.742-.502 3.905-.789 6.432-.885 5.057-.193 11.428.38 18.514 1.382 14.198 2.007 30.954 5.682 45.48 8.202l.342-1.97c-14.373-2.494-31.327-6.203-45.542-8.213-7.121-1.006-13.632-1.6-18.87-1.4-2.619.1-4.957.4-6.91.962-1.948.562-3.586 1.407-4.719 2.65l1.477 1.347zm-1.387.088c4.925 4.19 6.335 7.59 6.271 9.853-.063 2.213-1.538 3.6-3.127 3.954l.434 1.952c2.41-.536 4.601-2.648 4.692-5.849.09-3.15-1.855-7.078-6.973-11.433l-1.297 1.523zm3.144 13.807c-2.2.488-4.478-.79-5.352-3.278-.863-2.456-.366-6.273 3.595-10.617l-1.477-1.348c-4.288 4.702-5.185 9.268-4.005 12.628 1.17 3.33 4.372 5.3 7.673 4.567l-.434-1.952zm134.392-6.078c13.213 4.53 23.052 5.724 30.912 4.908 7.879-.819 13.687-3.649 18.835-7.017C327.071 15.574 334.453 7 350.813 7V5c-17.139 0-25.257 9.176-35.172 15.663-4.977 3.257-10.482 5.926-17.946 6.702-7.484.777-17.02-.341-30.057-4.811l-.649 1.892zM350.813 7c6.683 0 13.73.995 19.073 3.997 5.264 2.957 8.927 7.883 8.927 16.003h2c0-8.88-4.086-14.454-9.947-17.747C365.084 6.005 357.631 5 350.813 5v2zm28 20c0 2.574.165 5.693.002 8.95l1.997.1c.166-3.314.001-6.624.001-9.05h-2z"
					></path>
					<defs>
						<linearGradient
							id="paint0_linear_278_36"
							x1="0.813"
							x2="467.814"
							y1="14"
							y2="14"
							gradientUnits="userSpaceOnUse"
						>
							<stop
								stopOpacity="0"
								stopColor="currentColor"
							></stop>
							<stop
								offset="0.125"
								stopColor="currentColor"
							></stop>
							<stop offset="1" stopColor="currentColor"></stop>
						</linearGradient>
					</defs>
				</svg>
			);
		case 'down_03':
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="187"
					height="47"
					fill="none"
					viewBox="0 0 187 47"
					aria-hidden="true"
					role="presentation"
					className={twMerge(
						'text-black/60 dark:text-white/75',
						className,
					)}
				>
					<mask
						id="mask0_385_60"
						width="32"
						height="32"
						x="0"
						y="3"
						maskUnits="userSpaceOnUse"
						style={{ maskType: 'alpha' }}
					>
						<path
							fill="currentColor"
							d="M0 12.734 21.938 3l9.733 21.938L9.734 34.67z"
						></path>
					</mask>
					<g mask="url(#mask0_385_60)">
						<path
							fill="currentColor"
							d="m9.565 15.492 1.09-4.45q.111-.487.412-.826.302-.339.713-.52.411-.183.864-.18.453.005.89.249l4.03 2.178 4.462-.421a1.9 1.9 0 0 1 1.236.258q.561.339.825.933.12.275.163.584.042.31-.03.642l-.932 4.68 1.755 3.708q.377.789.072 1.581t-1.036 1.116q-.045.02-.533.155l-4.598.672-3.583 2.958a1 1 0 0 1-.226.168q-.132.073-.246.123-.732.325-1.524.02-.791-.306-1.123-1.115l-1.582-3.811-4.062-2.437a1.9 1.9 0 0 1-.496-.41 2.1 2.1 0 0 1-.324-.512 2.04 2.04 0 0 1-.14-1.21q.114-.637.616-1.107zm1.82 1.08L7.6 20l4.649 2.833 1.845 4.405 4.013-3.284 5.138-.749-2.038-4.347 1.039-5.302-5.103.46-4.552-2.494z"
						></path>
					</g>
					<mask
						id="mask1_385_60"
						width="28"
						height="28"
						x="41"
						y="19"
						maskUnits="userSpaceOnUse"
						style={{ maskType: 'alpha' }}
					>
						<path
							fill="currentColor"
							d="m41.927 22.178 23.894-2.25 2.251 23.893-23.894 2.251z"
						></path>
					</mask>
					<g mask="url(#mask1_385_60)">
						<path
							fill="currentColor"
							d="m50.119 27.835 2.447-3.872q.262-.426.655-.651t.84-.268q.45-.042.877.106.428.148.765.518l3.127 3.346 4.365 1.02q.666.139 1.09.639.423.5.485 1.147.027.298-.031.605a1.9 1.9 0 0 1-.233.6l-2.372 4.14.484 4.073q.108.87-.434 1.522-.54.654-1.337.729a10 10 0 0 1-.555-.023l-4.572-.825-4.338 1.664a1 1 0 0 1-.268.088 3 3 0 0 1-.273.039q-.796.075-1.45-.467-.654-.54-.71-1.414l-.288-4.116-3.077-3.603a1.9 1.9 0 0 1-.34-.545 2.1 2.1 0 0 1-.143-.59q-.06-.621.252-1.19.31-.57.936-.855zm1.381 1.602-4.678 2.048 3.506 4.165.348 4.763 4.849-1.838 5.11.925-.55-4.77 2.67-4.695-4.983-1.188-3.523-3.812z"
						></path>
					</g>
					<mask
						id="mask2_385_60"
						width="28"
						height="28"
						x="81"
						y="0"
						maskUnits="userSpaceOnUse"
						style={{ maskType: 'alpha' }}
					>
						<path
							fill="currentColor"
							d="M81 3.454 104.75 0l3.454 23.75-23.75 3.454z"
						></path>
					</mask>
					<g mask="url(#mask2_385_60)">
						<path
							fill="currentColor"
							d="m89.467 8.69 2.249-3.99q.24-.439.62-.684.382-.244.827-.31.445-.064.88.062.436.126.79.479l3.293 3.184 4.411.798q.672.105 1.12.583t.542 1.12q.043.297 0 .607t-.202.61l-2.16 4.256.689 4.043q.15.863-.357 1.542-.507.681-1.299.795a10 10 0 0 1-.555.005l-4.608-.593-4.249 1.881a1 1 0 0 1-.263.102q-.147.034-.27.052-.792.115-1.472-.392-.68-.509-.781-1.377l-.495-4.097-3.254-3.442a1.9 1.9 0 0 1-.368-.528 2.1 2.1 0 0 1-.173-.581q-.09-.618.192-1.203t.892-.9zm1.46 1.53-4.569 2.282 3.712 3.983.588 4.74 4.75-2.081 5.15.666-.79-4.736 2.431-4.825-5.037-.935-3.711-3.628z"
						></path>
					</g>
					<mask
						id="mask3_385_60"
						width="29"
						height="29"
						x="115"
						y="16"
						maskUnits="userSpaceOnUse"
						style={{ maskType: 'alpha' }}
					>
						<path
							fill="currentColor"
							d="m120.199 16 23.43 5.2-5.2 23.43-23.43-5.2z"
						></path>
					</mask>
					<g mask="url(#mask3_385_60)">
						<path
							fill="currentColor"
							d="m126.257 23.9 3.518-2.932q.38-.326.823-.42.444-.092.883.004.44.097.801.37.362.272.569.728l1.948 4.145 3.84 2.312q.591.336.841.942.25.607.109 1.24a2.1 2.1 0 0 1-.216.568q-.15.273-.405.499l-3.529 3.211-.791 4.025q-.165.86-.881 1.315-.715.456-1.497.283a10 10 0 0 1-.52-.193l-4.098-2.19-4.64.251a1 1 0 0 1-.282.002 3 3 0 0 1-.271-.048q-.781-.173-1.237-.889-.456-.715-.241-1.564l.991-4.006-1.821-4.373a1.8 1.8 0 0 1-.156-.624q-.02-.311.044-.604.137-.611.606-1.057a1.96 1.96 0 0 1 1.154-.525zm.822 1.95-5.082.51 2.057 5.04-1.132 4.64 5.179-.258 4.578 2.45.943-4.708 3.985-3.649-4.378-2.661-2.181-4.71z"
						></path>
					</g>
					<mask
						id="mask4_385_60"
						width="28"
						height="28"
						x="159"
						y="3"
						maskUnits="userSpaceOnUse"
						style={{ maskType: 'alpha' }}
					>
						<path
							fill="currentColor"
							d="m163.405 3.002 23.593 4.402-4.402 23.593-23.593-4.402z"
						></path>
					</mask>
					<g mask="url(#mask4_385_60)">
						<path
							fill="currentColor"
							d="m169.726 10.693 3.418-3.05q.368-.339.808-.447a2.067 2.067 0 0 1 1.696.316q.371.26.592.708l2.088 4.077 3.917 2.18q.602.317.872.914t.151 1.236a2.2 2.2 0 0 1-.196.574 1.9 1.9 0 0 1-.388.512l-3.419 3.33-.654 4.048a1.92 1.92 0 0 1-.836 1.345q-.7.48-1.486.333a10 10 0 0 1-.527-.175l-4.17-2.05-4.628.409a1 1 0 0 1-.282.01q-.15-.015-.272-.037-.787-.147-1.267-.847a1.92 1.92 0 0 1-.294-1.555l.855-4.037-1.968-4.31a1.9 1.9 0 0 1-.178-.617q-.03-.312.024-.606.115-.614.57-1.076a1.95 1.95 0 0 1 1.135-.564zm.888 1.92-5.061.683 2.227 4.968-.974 4.676 5.167-.435 4.658 2.293.782-4.737 3.859-3.781-4.465-2.512-2.34-4.632z"
						></path>
					</g>
				</svg>
			);
	}
};

export default Arrow;
